import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../UserContext';

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const { initialized, isAuthenticated } = useUser();

    if (!initialized) {
        return <div>Loading...</div>;
    }

    if (!isAuthenticated) {
        return <Navigate to="/" state={{ from: location, message: 'You are not logged in. Please log in to access this page.' }} replace />;
    }

    return children;
};

export default ProtectedRoute;
